/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const submitFeedbackBody = zod.object({
  "feature": zod.string(),
  "interestLevel": zod.number().nullish(),
  "feedback": zod.string().nullish()
})

